import { Divider as AntDivider } from 'antd'
import styled from 'styled-components'
import { space } from 'styled-system'

const Divider = styled(AntDivider)`
  ${space};
`

export default Divider